import { Box } from '@mui/material';
import React from 'react';
import { theme } from 'ui-sdk/src/theme';

export const MessageList: React.FC = ({ children }) => (
  <Box
    sx={{
      // need to be 80% to fit the chat box
      height: { xs: '100%', md: '80%' },
      overflow: 'auto',
      paddingBottom: theme.spacing(2),
    }}
  >
    <div style={{ paddingTop: theme.spacing(14) }}>{children}</div>
  </Box>
);
